import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/UserAccount'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class UserAccountStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "UserAccountStore",
			variables: true,
		})
	}
}

export async function load_UserAccount(params) {
  await initClient()

	const store = new UserAccountStore()

	await store.fetch(params)

	return {
		UserAccount: store,
	}
}
